import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { formatPageTitle, ROUTE_TITLES, SITE_TITLE } from "../constants/site";

export default function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isAdmin = pathname.startsWith("/admin");
    let page = ROUTE_TITLES[pathname];

    if (!page && pathname.startsWith("/programlar/") && pathname !== "/programlar") {
      page = "Program";
    }

    if (!page) {
      document.title = isAdmin ? formatPageTitle(null, { admin: true }) : SITE_TITLE;
      return;
    }

    document.title = formatPageTitle(page, { admin: isAdmin });
  }, [pathname]);

  return null;
}
